import { IconButton, Tooltip } from '@dixa/lib-shared-habla';

type SettingsIntegrationsDocumentationButtonProps = {
  onClick: () => void;
  tooltipContent?: string;
};

export const SettingsIntegrationsDocumentationButton = ({
  tooltipContent = 'Help and documentation',
  onClick,
}: SettingsIntegrationsDocumentationButtonProps): JSX.Element => {
  return (
    <Tooltip content={tooltipContent}>
      <IconButton icon="question" variant="tertiary" onClick={onClick} />
    </Tooltip>
  );
};
